import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Kids from './pages/Kids';
import './index.css';

function App() {
  const [currentDate, setCurrentDate] = useState<Date>(new Date());

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard currentDate={currentDate} setCurrentDate={setCurrentDate} />} />
          <Route path="/users" element={<Users />} />
          <Route path="/kids" element={<Kids />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;